export default __webpack_public_path__ + "static/image26-abe04be75cc5f783fc9a0798c4c1b78e.gif";